// Copyright (c) Ensho Health, 2021 to present

import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  StyledLink,
  StyledSubmitButton,
  StyledError,
  StyledInput,
  StyledForm,
  StyledInstructions
} from './FormChallenge.styles.js';

const FormChallenge = (props) => {
  const [fields, setFields] = useState({
    answer: ''
  });

  const onFieldChange = (event) => {
    const field = event.target.name;
    setFields({ ...fields, [field]: event.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (fields.answer) {
      props.onSubmit(fields);
    }
  };
  const isFormDisabled = !fields.answer || props.disabled;

  return (
    <StyledForm onSubmit={onSubmit}>
      <StyledInstructions>
        Please answer your recovery question: {props.recoveryQuestion}
      </StyledInstructions>
      <StyledInput
        onChange={onFieldChange}
        defaultValue={fields.answer}
        large
        type="text"
        name="answer"
        placeholder="Your Answer"
        intent={props.errorMessage ? 'danger' : ''}
      />

      {props.errorMessage && <StyledError>{props.errorMessage}</StyledError>}
      <StyledSubmitButton
        loading={props.loading}
        disabled={isFormDisabled}
        type="submit"
        intent="default"
      >
        Next
      </StyledSubmitButton>

      <StyledLink>
        <a
          href="mailto:support@ensho.ai"
          title="send and email to Ensho Health"
        >
          I forgot / am having trouble with my recovery answer
        </a>
      </StyledLink>
    </StyledForm>
  );
};

FormChallenge.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  errorMessage: PropTypes.string,
  recoveryQuestion: PropTypes.string
};

export default FormChallenge;
